/* @flow weak */
import http from '../lib/http';
import {findGetParameter} from '../lib/util';
import {FULL_LOADING_SHOW} from '../components/loadings/actions';

export const APP_OFFLINE = 'APP_OFFLINE';
export const APP_ONLINE = 'APP_ONLINE';
export const APP_SET_LOCATION = 'APP_SET_LOCATION';
export const APP_START = 'APP_START';
export const APP_STORAGE_LOAD = 'APP_STORAGE_LOAD';
export const REMOVE_ERRORS = 'REMOVE_ERRORS';
export const SET_ERROR_OFFLINE = 'SET_ERROR_OFFLINE';
export const FETCH_MIGRATION_DATA = 'FETCH_MIGRATION_DATA';

export function fetchMigrationData(migrationID, domain) {
    return {
        type: FETCH_MIGRATION_DATA,
        payload: {
            promise: getMigrationData(migrationID, domain)
        }
    }
}

export function setOfflineError(error) {
    return {
        type: SET_ERROR_OFFLINE,
        payload: {error}
    };
}

export const setLocation = (location) => ({
    type: APP_SET_LOCATION,
    payload: {location},
});

export const removeErrors = () => ({
    type: REMOVE_ERRORS
});

export const start = () => {
    const loadStorage = async(dispatch, storageEngine) => {
        let state = await storageEngine.load();
        let useMigrationData = false;
        const migrationId = findGetParameter('migrationId');
        const domain = findGetParameter('domain');
        if (!!migrationId && !! domain) {
            // Show loading until migration os done. Will be redirected
            dispatch({type: FULL_LOADING_SHOW});
            fetchMigrationData(migrationId, domain).payload.promise
                .then(res => {
                    // Performing a migration - loading state from retrieved data instead of localStorage
                    localStorage.setItem('domain', domain);
                    state = JSON.parse(res.data);
                    useMigrationData = true;
                    dispatch({type: APP_STORAGE_LOAD, payload: {state: state, useMigrationData: useMigrationData}});
                })
                .catch(()   => {
                    console.error("Migration request was parsed from query, but server failed to provide needed data. Will use normal redux state instead")
                    dispatch({type: APP_STORAGE_LOAD, payload: {state: state, useMigrationData: false}});
                })
        } else {
            dispatch({type: APP_STORAGE_LOAD, payload: {state: state, useMigrationData: useMigrationData}});
        }
    };
    return ({dispatch, storageEngine}) => {
        loadStorage(dispatch, storageEngine);
        return {
            type: APP_START,
        };
    };
};

async function getMigrationData(migrationId, domain) {
    const res = await http.get(`/app/get-migration-data/${migrationId}/${domain}`);
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/app/actions.js